import { useRef, useState, useEffect } from 'react'
import box from './data/index'
import styles from './styles'

import 'ckeditor5/ckeditor5.css'

import { withStyles } from '@material-ui/core'
import BoxButton from './components/box-button'
import DropdownBox from './components/dropdown-options'
import CKEditorComponent from './components/ck-editor'
import { useCourseSettings } from 'src/hooks/useCourseSettings'
import { useSelector } from 'react-redux'
import { initialThemeSettings } from 'src/model/theme'

const CkEditor = props => {
  const { classes, saveData, initialData, font, fontSize, page } = props
  const editorRef = useRef(null)
  const dropdownRef = useRef(null)
  const [isOpen, setIsOpen] = useState(true)
  const [selectedFeatureIndex, setSelectedFeatureIndex] = useState(0)
  const [doubleClickData, setDoubleClickData] = useState(null)
  const [language, setLanguage] = useState('English') // Initialize language state
  const SETTING_KEY = 'language'
  const { exists, value } = useCourseSettings(SETTING_KEY)
  const pageUrl = window.location.pathname.split('/')[1]
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )
  const initialTheme = initialThemeSettings
  const themeSettings = useCourseSettings('theme')
  const theme =
    pageUrl === 'mini-course'
      ? themeSettings.value
        ? themeSettings.value?.layout
        : initialTheme?.layout
      : 0

  // Create a safe version of landingPageData with fallback to empty object
  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings || {} : collectionSettings || {}

  useEffect(() => {
    const languages = window.CONSTANTS?.LANGUAGES || []
    // Set language based on course settings
    if (exists && value?.selected && languages.length > 0) {
      const languageObj = languages.find(x => x.countryCode === value.selected)
      if (languageObj) {
        setLanguage(languageObj.name)
      } else {
        setLanguage('English') // Fallback if language not found
      }
    } else {
      setLanguage('English') // Default language
    }

    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen, exists, value])

  const handleCategoryClick = index => {
    setSelectedFeatureIndex(index)
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }
  let sampleHtml
  let sampleElement
  const handleDragStart = dataValues => event => {
    event.dataTransfer.clearData()
    sampleHtml = dataValues.html
    sampleElement = dataValues.element

    document.addEventListener('DOMContentLoaded', function () {
      let checkTextarea = setInterval(function () {
        const textarea = document.querySelector(
          '.ck.ck-reset.ck-input.ck-input-text.raw-html-embed__source',
        )
        if (textarea) {
          clearInterval(checkTextarea)
          setupVSCodeEffect(textarea)
        }
      }, 500)

      function setupVSCodeEffect(textarea) {
        const container = textarea.closest('.ck.ck-labeled-field-view')
        if (container) {
          container.style.marginTop = '28px'
          container.style.position = 'relative'
        }

        const copyButton = document.createElement('button')
        copyButton.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
              </svg>
              copy
          `
        copyButton.style.position = 'absolute'
        copyButton.style.top = '-22px'
        copyButton.style.right = '10px'
        copyButton.style.backgroundColor = 'rgba(60, 60, 60, 0.7)'
        copyButton.style.color = '#fff'
        copyButton.style.border = 'none'
        copyButton.style.borderRadius = '4px'
        copyButton.style.padding = '2px 8px'
        copyButton.style.fontSize = '12px'
        copyButton.style.cursor = 'pointer'
        copyButton.style.display = 'flex'
        copyButton.style.alignItems = 'center'
        copyButton.style.gap = '4px'
        copyButton.style.zIndex = '100'
        container.appendChild(copyButton)

        copyButton.addEventListener('click', function () {
          textarea.select()
          document.execCommand('copy')
          this.innerHTML = 'Copied!'
          setTimeout(() => {
            this.innerHTML = `
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                      </svg>
                      copy
                  `
          }, 2000)
        })

        textarea.addEventListener('keydown', function (e) {
          if (e.key === 'Tab') {
            e.preventDefault()
            const start = this.selectionStart
            const end = this.selectionEnd

            this.value =
              this.value.substring(0, start) +
              '    ' +
              this.value.substring(end)
            this.selectionStart = this.selectionEnd = start + 4
          }
        })
      }
    })

    if (box[selectedFeatureIndex].value !== 'embed') {
      if (
        box[selectedFeatureIndex].value === 'actions' &&
        dataValues.value === 'interactiveActivity'
      ) {
        event.dataTransfer.setData('text/html', sampleHtml)
        event.dataTransfer.setData('dragDropData', JSON.stringify(dataValues))
        event.dataTransfer.setData('boxData', box[selectedFeatureIndex].value)
        event.dataTransfer.setData('font', font)
        event.dataTransfer.setData('language', language)
      } else {
        if (sampleElement !== undefined) {
          event.dataTransfer.setData('element', JSON.stringify(sampleElement))
        } else {
          event.dataTransfer.setData('text/html', sampleHtml)
        }
      }
    } else {
      event.dataTransfer.setData('text/html', sampleHtml)
      event.dataTransfer.setData('dragDropData', JSON.stringify(dataValues))
      event.dataTransfer.setData('boxData', box[selectedFeatureIndex].value)
    }
  }

  const handleDoubleClick = dataValues => {
    setDoubleClickData({
      data: dataValues,
      type: box[selectedFeatureIndex].value,
    })
    setIsOpen(false)
  }

  const handleDrop = () => {
    setIsOpen(false)
  }

  return (
    <div className={classes.CKEditor}>
      <CKEditorComponent
        editorRef={editorRef}
        onDropClose={handleDrop}
        saveData={saveData}
        initialData={initialData}
        doubleClickData={doubleClickData}
        setDoubleClickData={setDoubleClickData}
        fontSize={fontSize}
        fontFamily={page === 'landing-page' ? landingPageData.font : font}
        page={page}
        theme={theme}
        language={language}
        setIsOpen={setIsOpen}
      />

      <BoxButton
        box={box}
        classes={classes}
        handleCategoryClick={handleCategoryClick}
        isOpen={isOpen}
      />

      {isOpen && (
        <div ref={dropdownRef}>
          <DropdownBox
            box={box}
            selectedFeatureIndex={selectedFeatureIndex}
            classes={classes}
            handleClose={handleClose}
            handleDragStart={handleDragStart}
            handleDoubleClick={handleDoubleClick}
          />
        </div>
      )}
    </div>
  )
}

export default withStyles(styles)(CkEditor)
